import * as React from 'react';
import { Button, Modal, Alert, Icon } from '@cloudscape-design/components';
import {
  useCustomTranslation,
  ClientErrorCode,
} from '@amzn/work-spaces-web-client-core-lib';
import styles from './styles.module.scss';

interface BlockPlatformModalProps {
  header: string;
  alertTitle: string;
  alertDescription: string;
  onClose: () => void;
  isIncludeContinue?: boolean;
}

export const shouldShowBlockPlatformModal = (error?: any) => {
  if (!error) return false;
  return (
    error?.clientCode === ClientErrorCode.AllocateResourcePcoipWebAcessDenied
  );
};

const BlockPlatformModal: React.FC<BlockPlatformModalProps> = ({
  header,
  alertDescription,
  alertTitle,
  onClose,
  isIncludeContinue,
}) => {
  const [visible, setVisible] = React.useState(true);
  const handleContinue = () => {
    setVisible(false);
    onClose?.();
  };
  const handleDismiss = ({ detail }: any) => {
    if (detail.reason === 'closeButton') {
      setVisible(false);
      onClose?.();
    }
  };
  const { t } = useCustomTranslation();
  return (
    <Modal
      data-testid="end-user-modal"
      closeAriaLabel="Close"
      visible={visible}
      onDismiss={handleDismiss}
      footer={
        <div className={styles['modal-footer']}>
          <Button
            ariaLabel="Download latest client"
            href="https://clients.amazonworkspaces.com/"
            iconAlign="right"
            iconName="external"
            target="_blank"
          >
            {t('ws-pcoip-download-client')}
          </Button>
          {isIncludeContinue && (
            <Button
              ariaLabel="Continue"
              iconAlign="right"
              variant="primary"
              onClick={handleContinue}
              className={styles['continue-button']}
            >
              {t('ws-pcoip-continue')}
            </Button>
          )}
        </div>
      }
      header={header}
    >
      {isIncludeContinue ? (
        <>
          <div className={styles['warning-alert']}>
            <div className={styles['warning-icon']}>
              <Icon name="status-warning" size="normal" variant="normal" />
            </div>
            <div className={styles['warning-title']}>{alertTitle}</div>
          </div>
          <div className={styles['alert-description']}>{alertDescription}</div>
        </>
      ) : (
        <>
          <Alert statusIconAriaLabel="Error" type="error">
            {alertTitle}
          </Alert>
          <div style={{ paddingTop: '10px' }}>{alertDescription}</div>
        </>
      )}
    </Modal>
  );
};

export default BlockPlatformModal;
